import React from 'react';
import StartPage from '../pages/StartPage';
import GenerateTextPage from '../pages/GenerateTextPage';
import WorkflowListPage from '../pages/WorkflowListPage';
import CreateWorkflowPage from '../pages/CreateWorkflowPage';
import ExecuteWorkflowPage from '../pages/ExecuteWorkflowPage';
import ExecuteTemplatePage from '../pages/ExecuteTemplatePage';
import EditWorkflowPage from '../pages/EditWorkflowPage';
import MemeGeneratorPage from '../pages/MemeGeneratorPage';
import ScheduledPostsPage from '../pages/ScheduledPostsPage';
import SeriesFormatsPage from '../pages/SeriesFormatsPage';
import SeriesFormatWorkflowPage from '../pages/SeriesFormatWorkflowPage';
import PostIdeasPage from '../pages/PostIdeasPage';
import EditorialPlanPageNew from '../pages/EditorialPlanPageNew';
import ContentBriefPage from '../pages/ContentBriefPage';
import TemplateBrowserPage from '../pages/TemplateBrowserPage';
import GesamtprozessPage from '../pages/GesamtprozessPage';
import StrategyWorkflowPage from '../pages/StrategyWorkflowPage';
import LinkedInProfilesPage from '../pages/LinkedInProfilesPage';
import LeadMagnetPage from '../pages/LeadMagnetPage';
import { PageTabs } from '../components/ui/PageTabs';
import LinkedInStatisticsPage from '../pages/LinkedInStatisticsPage';
import EmailWorkflowPage from '../pages/EmailWorkflowPage';
import BlogWorkflowPage from '../pages/BlogWorkflowPage';
import LinkedInPostGeneratorPage from '../pages/LinkedInPostGeneratorPage';
import PublicationCalendarPage from '../pages/PublicationCalendarPage';
import SalesCampaignsPage from '../pages/SalesCampaignsPage';
import SalesCampaignDetailPage from '../pages/SalesCampaignDetailPage';
import AntwortenClearingPage from '../pages/AntwortenClearingPage';
import TenantManagementPage from '../pages/TenantManagementPage';
import UserManagementPage from '../pages/UserManagementPage';
import LeadSyncPage from '../pages/LeadSyncPage';
import OutreachInboxPage from '../pages/OutreachInboxPage';
import AuswertungPage from '../pages/AuswertungPage';
import PipelinePage from '../pages/PipelinePage';
import CompaniesPage from '../pages/CompaniesPage';
import CompanyAktePage from '../pages/CompanyAktePage';
import TasksPage from '../pages/TasksPage';
import QuotesPage from '../pages/QuotesPage';
import MailboxesPage from '../pages/MailboxesPage';
import FlyerGeneratorPage from '../pages/FlyerGeneratorPage';
import FlyersPage from '../pages/FlyersPage';
import ProfilePage from '../pages/ProfilePage';
import MeinProfilPage from '../pages/MeinProfilPage';
import NotFoundPage from '../pages/NotFoundPage';
import VertriebPage from '../pages/VertriebPage';
import GtmOverviewPage from '../pages/GtmOverviewPage';
import GtmSetupPage from '../pages/GtmSetupPage';
import ValuePropPage from '../pages/ValuePropPage';
import ResearchHubPage from '../pages/ResearchHubPage';
import PersonaInsightsPage from '../pages/PersonaInsightsPage';
import ListBuildingPage from '../pages/ListBuildingPage';
import IcebreakerPage from '../pages/IcebreakerPage';
import SequencesPage from '../pages/SequencesPage';
import DuplicatesPage from '../pages/DuplicatesPage';
import ReplyHandlerPage from '../pages/ReplyHandlerPage';
import CampaignArchitectPage from '../pages/CampaignArchitectPage';
import CopywritingStudioPage from '../pages/CopywritingStudioPage';
import IcpCampaignsPage from '../pages/IcpCampaignsPage';
import IcpCampaignWizardPage from '../pages/IcpCampaignWizardPage';
import SignalCampaignsPage from '../pages/SignalCampaignsPage';
import SignalCampaignDetailPage from '../pages/SignalCampaignDetailPage';
import PublicOutreachPage from '../pages/PublicOutreachPage';
import PublicOutreachDetailPage from '../pages/PublicOutreachDetailPage';
import OutboundAnalysisPage from '../pages/OutboundAnalysisPage';
import PipelineAnalysisPage from '../pages/PipelineAnalysisPage';
import SlideDeckPage from '../pages/SlideDeckPage';
import OptionsPage from '../pages/OptionsPage';
import MediaLibraryPage from '../pages/MediaLibraryPage';
import { LoadingState } from '../components/ui';

// ERP-Seiten laden verzoegert: sie haengen nicht am Startpfad der meisten
// Nutzer, und ihr Code (Belegtabellen, Buchhaltung) soll das Erstbundle
// nicht aufblaehen.
const AuftraegePage = React.lazy(() => import('../pages/AuftraegePage'));
const RechnungenPage = React.lazy(() => import('../pages/RechnungenPage'));
const ZahlungenPage = React.lazy(() => import('../pages/ZahlungenPage'));
const MahnwesenPage = React.lazy(() => import('../pages/MahnwesenPage'));
const TagesabrechnungPage = React.lazy(() => import('../pages/TagesabrechnungPage'));
const LieferantenPage = React.lazy(() => import('../pages/LieferantenPage'));
const VertraegePage = React.lazy(() => import('../pages/VertraegePage'));
const BestellungenPage = React.lazy(() => import('../pages/BestellungenPage'));
const EingangsrechnungenPage = React.lazy(() => import('../pages/EingangsrechnungenPage'));
const BuchhaltungPage = React.lazy(() => import('../pages/BuchhaltungPage'));
const LagerPage = React.lazy(() => import('../pages/LagerPage'));
const ProjektePage = React.lazy(() => import('../pages/ProjektePage'));
const ErpEinstellungenPage = React.lazy(() => import('../pages/ErpEinstellungenPage'));
const ErpEinrichtungPage = React.lazy(() => import('../pages/ErpEinrichtungPage'));
const ErpCockpitPage = React.lazy(() => import('../pages/ErpCockpitPage'));

const verzoegert = (Seite: React.LazyExoticComponent<React.ComponentType>) => (
  <React.Suspense fallback={<LoadingState />}>
    <Seite />
  </React.Suspense>
);

/**
 * Seite je Routen-Kennung aus routes.ts. Getrennt von der Registry, damit
 * routes.ts ohne Seiten-Imports testbar bleibt (und die Palette keine
 * 40 Seiten laden muss).
 */
/** Sammelseite: Reiterleiste aus der Registry ueber der eigentlichen Seite. */
const mitReitern = (entryId: string, seite: React.ReactElement) => (
  <>
    <PageTabs entryId={entryId} />
    {seite}
  </>
);

export const ROUTE_ELEMENTS: Record<string, React.ReactElement> = {
  home: <StartPage />,
  text: <GenerateTextPage />,
  'li-overview': <GesamtprozessPage />,
  'li-strategy': <StrategyWorkflowPage />,
  'li-profiles': <LinkedInProfilesPage />,
  'li-series': <SeriesFormatsPage />,
  'li-series-workflow': <SeriesFormatWorkflowPage />,
  'li-ideas': <PostIdeasPage />,
  'li-plan': <EditorialPlanPageNew />,
  'li-briefs': <ContentBriefPage />,
  'li-post': <LinkedInPostGeneratorPage />,
  'li-media': <MediaLibraryPage />,
  'li-calendar': <PublicationCalendarPage />,
  'li-stats': <LinkedInStatisticsPage />,
  'li-scheduled': <ScheduledPostsPage />,
  'li-leadmagnets': mitReitern('li-flyer-new', <LeadMagnetPage />),
  'li-flyer-new': mitReitern('li-flyer-new', <FlyerGeneratorPage />),
  'li-flyers': mitReitern('li-flyer-new', <FlyersPage />),
  templates: <TemplateBrowserPage />,
  memes: mitReitern('li-flyer-new', <MemeGeneratorPage />),
  email: mitReitern('workflows', <EmailWorkflowPage />),
  blog: mitReitern('workflows', <BlogWorkflowPage />),
  workflows: mitReitern('workflows', <WorkflowListPage />),
  'workflows-create': <CreateWorkflowPage />,
  'workflows-template': <ExecuteTemplatePage />,
  'workflows-execute': <ExecuteWorkflowPage />,
  'workflows-edit': <EditWorkflowPage />,
  // Vertrieb auf sieben Eintraege (Entscheidung 13): Heute, Postfaecher und Auswertung
  // sind Reiter von Cockpit, Leads & Outreach und Pipeline; ihre SalesProcessBar bleibt.
  'sales-overview': mitReitern('sales-overview', <VertriebPage />),
  today: mitReitern('sales-overview', <TasksPage />),
  leads: mitReitern('leads', <LeadSyncPage />),
  inbox: <OutreachInboxPage />,
  pipeline: mitReitern('pipeline', <PipelinePage />),
  quotes: mitReitern('quotes', <QuotesPage />),
  contracts: mitReitern('quotes', verzoegert(VertraegePage)),
  companies: mitReitern('companies', <CompaniesPage />),
  'companies-detail': <CompanyAktePage />,
  // Kampagnen: vier Arten als Reiter einer Sammelseite, auch auf den Detailseiten.
  campaigns: mitReitern('campaigns', <SalesCampaignsPage />),
  'campaigns-detail': mitReitern('campaigns', <SalesCampaignDetailPage />),
  mailboxes: mitReitern('leads', <MailboxesPage />),
  report: mitReitern('pipeline', <AuswertungPage />),
  'gtm-overview': mitReitern('gtm-overview', <GtmOverviewPage />),
  'gtm-setup': mitReitern('gtm-overview', <GtmSetupPage />),
  'value-props': mitReitern('gtm-overview', <ValuePropPage />),
  research: mitReitern('gtm-overview', <ResearchHubPage />),
  'persona-insights': mitReitern('gtm-overview', <PersonaInsightsPage />),
  'list-building': mitReitern('gtm-overview', <ListBuildingPage />),
  icebreaker: mitReitern('campaign-architect', <IcebreakerPage />),
  sequences: mitReitern('campaign-architect', <SequencesPage />),
  duplicates: mitReitern('companies', <DuplicatesPage />),
  'reply-handler': mitReitern('campaign-architect', <ReplyHandlerPage />),
  'campaign-architect': mitReitern('campaign-architect', <CampaignArchitectPage />),
  'copywriting-studio': mitReitern('campaign-architect', <CopywritingStudioPage />),
  'icp-campaigns': mitReitern('campaigns', <IcpCampaignsPage />),
  'icp-campaigns-detail': mitReitern('campaigns', <IcpCampaignWizardPage />),
  'signal-campaigns': mitReitern('campaigns', <SignalCampaignsPage />),
  'signal-campaigns-detail': mitReitern('campaigns', <SignalCampaignDetailPage />),
  'public-outreach': mitReitern('campaigns', <PublicOutreachPage />),
  'public-outreach-detail': mitReitern('campaigns', <PublicOutreachDetailPage />),
  'outbound-analysis': mitReitern('outbound-analysis', <OutboundAnalysisPage />),
  'pipeline-analysis': mitReitern('outbound-analysis', <PipelineAnalysisPage />),
  'slide-deck': mitReitern('li-flyer-new', <SlideDeckPage />),
  options: <OptionsPage />,
  'erp-cockpit': verzoegert(ErpCockpitPage),
  'erp-orders': verzoegert(AuftraegePage),
  'erp-invoices': verzoegert(RechnungenPage),
  'erp-payments': verzoegert(ZahlungenPage),
  'erp-dunning': verzoegert(MahnwesenPage),
  'erp-tagesabrechnung': verzoegert(TagesabrechnungPage),
  'erp-suppliers': verzoegert(LieferantenPage),
  'erp-purchase-orders': verzoegert(BestellungenPage),
  'erp-purchase-invoices': verzoegert(EingangsrechnungenPage),
  'erp-accounting': verzoegert(BuchhaltungPage),
  'erp-stock': verzoegert(LagerPage),
  'erp-projects': verzoegert(ProjektePage),
  'erp-settings': verzoegert(ErpEinstellungenPage),
  'erp-einrichtung': verzoegert(ErpEinrichtungPage),
  tenant: <TenantManagementPage />,
  'reply-clearing': <AntwortenClearingPage />,
  users: <UserManagementPage />,
  profile: <ProfilePage />,
  'mein-profil': <MeinProfilPage />,
  'not-found': <NotFoundPage />,
};
